import React from 'react';

import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { useExtra } from 'apps/promo/hooks/selectors';

import styles from './AppReviews.module.css';

const REVIEW_TYPES = ['apple', 'android', 'huawei'];

const renderReviewItem = (item, type) => (
    <div className={styles.reviewItem} key={type}>
        <img src={item?.rating_app_icon?.url} alt={item?.title} />
        <div className={styles.rating}>
            <PromoText isMedium>{item?.rating_number}</PromoText>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                    d="M6.80681 0.400176C6.98012 -0.133215 7.73472 -0.133216 7.90803 0.400175L9.24807 4.52437C9.32557 4.76291 9.54786 4.92441 9.79868 4.92441H14.1351C14.696 4.92441 14.9291 5.64209 14.4754 5.97174L10.9672 8.52063C10.7642 8.66806 10.6793 8.92938 10.7568 9.16791L12.0969 13.2921C12.2702 13.8255 11.6597 14.269 11.206 13.9394L7.69772 11.3905C7.49481 11.2431 7.22004 11.2431 7.01713 11.3905L3.50888 13.9394C3.05515 14.269 2.44466 13.8255 2.61797 13.2921L3.958 9.16792C4.0355 8.92938 3.9506 8.66806 3.74768 8.52063L0.239434 5.97174C-0.214295 5.64209 0.0188904 4.92441 0.57973 4.92441H4.91617C5.16698 4.92441 5.38927 4.76291 5.46678 4.52437L6.80681 0.400176Z"
                    fill="#4E4E4E"
                />
            </svg>
            <PromoText isMedium>{item?.rating_text}</PromoText>
        </div>
        <PromoText color="gray40" isMedium>
            {item?.reviews_text}
        </PromoText>
    </div>
);

const AppReviews = () => {
    const downloadButtons = useExtra()?.downloadButtons;

    const byType = {};
    for (const item of downloadButtons ?? []) {
        byType[item.type] = item;
    }

    return <div className={styles.reviewsContainer}>{REVIEW_TYPES.map((type) => renderReviewItem(byType[type], type))}</div>;
};

export default AppReviews;
